import { types as t } from 'mobx-state-tree';

import { Translation } from 'models/ui';

export const Location = t.model('Location', {
  externalId: t.maybeNull(t.string),
  id: t.number,
  translations: t.array(Translation),
  isActive: t.maybeNull(t.boolean),
});
